<template>
  <nav>
    <AlertMessages
      v-if="alertValue"
      :alert-type="alertType" 
      :alert-msg="alertMsg"
      @reset="alertValue = false"
  />
  <v-row 
      v-if="!loadingData"
        align="center"
        class="mx-auto"
      >
        <v-col
            cols="11"
            class="mx-auto px-0"
        >
            <p class="text-h6">{{ $t('chartsTitle') }}</p>
            <v-row>
              <v-col cols="12" md="6">
                <v-card rounded="xxl" class="pa-5">
                  <KpiChart 
                    :title="$t('chartsTotalProductsTitle')"
                    :total="totalProducts" 
                    :data="productsByMonth"
                    :text-left="$t('products')"
                    downloaded-file-title="Total-number-products"
                    @getNewChartData="getNewChartData"
                    id="KpiProducts"
                    data-testid="kpi-products"
                  />
                </v-card>
              </v-col>
              <v-col cols="12" md="6">
                <v-card rounded="xxl" class="pa-5">
                  <KpiChart 
                    :title="$t('chartsTotalParticipantsTitle')"
                    :total="totalParticipants" 
                    :data="participantsByMonth"
                    :text-left="$t('participants')"
                    downloaded-file-title="Total-number-participants"
                    @getNewChartData="getNewChartData"
                    id="KpiParticipants"
                    data-testid="kpi-participants"
                  />
                </v-card>
              </v-col>
              <v-col cols="12" md="6">
                <v-card rounded="xxl" class="pa-5">
                  <KpiChart
                    :title="$t('chartsTotalOrdersTitle')"
                    :total="totalOrders" 
                    :data="ordersByMonth"
                    :text-left="$t('orders')"
                    downloaded-file-title="Total-number-orders"
                    @getNewChartData="getNewChartData"
                    id="KpiOrders"
                    data-testid="kpi-orders"
                  />
                </v-card>
            </v-col>
            <v-col cols="12" md="6">
                <v-card rounded="xxl" class="pa-5">
                  <KpiChart
                    :title="$t('chartsTotalSalesTitle')" 
                    :total="totalSales" 
                    :data="salesByMonth"
                    :text-left="$t('sales')"
                    downloaded-file-title="Total-sales"
                    @getNewChartData="getNewChartData"
                    id="KpiSales"
                    data-testid="kpi-sales"
                  />
                </v-card>
            </v-col>
          </v-row>
        </v-col>
    </v-row>
  </nav>
</template>
<script>
import i18n from '../../plugins/i18n'
import { repeatedMethodsMixin } from '../../mixins/repeatedMethodsMixin'
import { getStoreOverview } from '../../api/productApi'
import AlertMessages  from '../../components/AlertMessages'
import KpiChart from '../../components/KpiChart.vue'

export default {
  components: {
    AlertMessages,
    KpiChart
  },
  mixins: [repeatedMethodsMixin],
  data(){
    return{
      alertType: '',
      alertMsg: '',
      alertValue:false,
      spaceId: window.$cookies.get('space_id'),
      loadingData: false,
      space: window.location.host.split('.')[0],
      totalProducts: 0,
      totalParticipants: 0,
      totalOrders: 0,
      totalSales: 0,
      productsByMonth: [],
      participantsByMonth: [],
      ordersByMonth: [],
      salesByMonth: [],
    }
  },
  async created(){
  },
  methods:{
    async getNewChartData(id, created, startDate, endDate, currency){
      if(created == true){
        if(id === "KpiParticipants"){
          try {
            const response = await getStoreOverview(this.spaceId, startDate, endDate, currency);
            if (response.status == 200) {
              const data = response.data.meta
              this.totalProducts = data.total_products
              this.totalParticipants = data.total_participants
              this.participantsByMonth = data.participants_by_month
              this.totalOrders = data.total_orders
              this.productsByMonth = data.products_by_month
              this.ordersByMonth = data.orders_by_month
              this.totalSales = parseInt(data.total_sales)
              this.salesByMonth = data.sales_by_month
            }
          } catch (e) {
            if(e.response){
              if(e.response.status == 404) {
                this.$router.push({name: 'PageNotFound'})
              } else if(e.response.status == 403){
                this.$router.push({name: 'PageAccessDenied'})
              } else if(e.response.status == 400){
                for(let i = 0; i < e.response.data.errors.length; i++){
                    if(e.response.data.errors[i].detail == 'Invalid date parameters!'){
                        this.alertValue = true
                        this.alertType = 'error'
                        this.alertMsg = i18n.t('invalidDateError');
                    }else {
                      this.alertValue = true
                      this.alertType = 'error'
                      this.alertMsg = i18n.t('serverError')
                    }
                }
              } else {
                this.alertValue = true
                this.alertType = 'error'
                this.alertMsg =  i18n.t('serverError')
              }
            }
          }
        }
      }else{
        try {
          const response = await getStoreOverview(this.spaceId, startDate, endDate, currency);
          if (response.status == 200) {
            const data = response.data.meta
            if (id === "KpiParticipants") {
              this.totalParticipants = data.total_participants
              this.participantsByMonth = data.participants_by_month
            } else if (id === "KpiOrders") {
              this.totalOrders = data.total_orders
              this.ordersByMonth = data.orders_by_month
            } else if (id === "KpiSales") {
              this.totalSales = parseInt(data.total_sales)
              this.salesByMonth = data.sales_by_month
            } else if (id === "KpiProducts") {
              this.totalProducts = parseInt(data.total_products)
              this.productsByMonth = data.products_by_month
            }
          }
        } catch (e) {
          if(e.response){
            if(e.response.status == 404) {
              this.$router.push({name: 'PageNotFound'})
            }
            else if(e.response.status == 403){
              this.$router.push({name: 'PageAccessDenied'})
            } else if(e.response.status == 400){
                for(let i = 0; i < e.response.data.errors.length; i++){
                    if(e.response.data.errors[i].detail == 'Invalid date parameters!'){
                      this.alertValue = true
                      this.alertType = 'error'  
                      this.alertMsg = i18n.t('invalidDateError');
                    }else {
                      this.alertValue = true
                      this.alertType = 'error'
                      this.alertMsg = i18n.t('serverError')
                    }
                }
            } else {
              this.alertValue = true
              this.alertType = 'error'
              this.alertMsg =  i18n.t('serverError')
            }
          }
        }
      }
    }
  }
}
</script>
